// ** React Imports
import { useState, useEffect, useRef, useCallback } from 'react'

// ** MUI Imports
import { 
  Box, 
  Tabs, 
  Tab, 
  Typography, 
  IconButton,
  Card,
  CardHeader,
  CardContent,
  useTheme,
  styled,   
  Chip,
  Button
} from '@mui/material'
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers-pro";

// ** Icon Imports
import Icon from "components/icon";
import { FilterList, Today } from '@mui/icons-material';

// ** Custom Component Imports
import CustomChip from "../../../../components/mui/chip";

// ** Google Maps Loader
import { Loader } from '@googlemaps/js-api-loader'
import { GetFormatedDateStamp } from 'components/formatDate';

// ** Third-Party Imports
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";

// ** Logic Imports
import { useJobListLogic } from 'screens/DispatchBoard/logic/job-list-logic';

// ** Other Component Imports
import JobDetailDialog from 'screens/WorkOrders/component/JobDetail';

// Styled components (keep your existing styled components)
const MapContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1)
}))

const TabsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`
}))

const DateFilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',  
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(2)
}))

const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  height: '600px',
}))

const JobsColumn = styled(Box)(({ theme }) => ({
  width: '300px',
  height: '100%',
  overflowY: 'auto',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius
}))

const MapColumn = styled(Box)(({ theme }) => ({
  flex: 1,
  height: '100%',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden'
}))

const JobCard = styled(Card)(({ theme, selected }) => ({
  margin: theme.spacing(2),
  cursor: 'pointer',
  border: selected ? `2px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.divider}`,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[4]
  }
}))

const EquipmentList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
  marginTop: theme.spacing(1)
}))

const MapComponent = props => {
  // ** Props
  const {
    jobSites = [],
    crews = [],
    equipment = [],
    propSelectedDate,
    onDateChange,
    onFilterClick,
    onJobSiteSelect,
    selectedJobSite,
    apiKey,
    setLoading
  } = props

  // ** State
  const [activeTab, setActiveTab] = useState(0)
  const [map, setMap] = useState(null)
  const [markers, setMarkers] = useState([])
  const [googleMaps, setGoogleMaps] = useState(null)
  const [datePickerAnchor, setDatePickerAnchor] = useState(null)
  const [selectedDate, setSelectedDate] = useState(() => {
    // Initialize with prop or current date at start of day
    const date = propSelectedDate ? new Date(propSelectedDate) : new Date()
    date.setHours(0, 0, 0, 0)
    return date
  });
  // ** Refs
  const mapRef = useRef(null)
  const theme = useTheme();

  const { JobListProps } =  useJobListLogic(selectedDate, setLoading);
  const {
    jobList,
    columnsJobList,
    jobListPaginationModel,
    setJobListPaginationModel,
    openJobDetail,
    handleCloseJobDetail,
    selectedWorkReq,
    selectedJob,
    setSelectedJob,
    fetchWorkRequirements,
    rules,
    fetchJobs
  } = JobListProps;

  useEffect(() => {
    if (propSelectedDate) {
      const newDate = new Date(propSelectedDate)
      newDate.setHours(0, 0, 0, 0)
      setSelectedDate(newDate)
    }
  }, [propSelectedDate]);

//   useEffect(() => {
//     if (!map || !googleMaps) return
  
//     const updateMarkers = async () => {
//       // Clear existing markers
//       markers.forEach(marker => marker.setMap(null))
      
//       const currentData = getCurrentData()
//       if (!currentData.length) return
  
//       const newMarkers = []
      
//       for (const item of currentData) {
//         if (item.address) {
//           try {
//             const geocoder = new googleMaps.Geocoder()
//             const result = await new Promise((resolve, reject) => {
//               geocoder.geocode({ address: item.address }, (results, status) => {
//                 if (status === 'OK' && results[0]) {
//                   resolve(results[0])
//                 } else {
//                   reject(new Error(`Geocoding failed: ${status}`))
//                 }
//               })
//             })
  
//             const isSelected = item.id === selectedJobSite?.id
//             const marker = new googleMaps.Marker({
//               position: result.geometry.location,
//               map: map,
//               title: item.title,
//               icon: getMarkerIcon(
//                 item.status || (item.type === 'merged-equipment' ? 'equipment' : 'default'),
//                 isSelected,
//                 theme,
//                 googleMaps,
//                 activeTab
//               ),
//               animation: isSelected ? googleMaps.Animation.BOUNCE : null
//             })
  
//             marker.addListener('click', () => {
//               if (onJobSiteSelect) {
//                 onJobSiteSelect(item)
//               }
//             })
  
//             newMarkers.push(marker)
//           } catch (error) {
//             console.error(`Failed to geocode address for ${item.title}:`, error)
//           }
//         }
//       }
      
//       setMarkers(newMarkers)
//     }
  
//     updateMarkers()
//   }, [jobSites, equipment, activeTab,selectedJobSite])

  // ** Handle date change
  const handleDateChange = (event) => {
    const newDate = new Date(event.target.value + 'T00:00:00')
    setSelectedDate(newDate)
    if (onDateChange) {
      onDateChange(newDate)
    }
  }

  // ** Handle Today button click
  const handleTodayClick = () => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    setSelectedDate(today)
    if (onDateChange) {
      onDateChange(today)
    }
  }

  // ** Format date for display
  const formatDisplayDate = (date) => {
    if (!date) return 'Select Date'
    return new Date(date).toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric',
      year: 'numeric'
    })
  }

  // ** Format for native input (YYYY-MM-DD)
  const formatForInput = (date) => {
    if (!date) return ''
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  // ** Initialize Google Maps
  useEffect(() => {
    const initMap = async () => {
      if (!apiKey) {
        console.error('Google Maps API key is required')
        return
      }

      const loader = new Loader({
        apiKey: apiKey,
        version: 'weekly',
        libraries: ['places', 'geometry']
      })

      try {
        const google = await loader.load()
        setGoogleMaps(google.maps)
        
        const mapInstance = new google.maps.Map(mapRef.current, {
          center: { lat: 39.8283, lng: -98.5795 },
          zoom: 4,
          styles: getMapStyles(theme),
          disableDefaultUI: false,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: true
        })

        setMap(mapInstance)
      } catch (error) {
        console.error('Error loading Google Maps:', error)
      }
    }

    initMap()
  }, [apiKey, theme])

  // ** Merge equipment by job ID
  const getMergedEquipment = useCallback(() => {
    const equipmentByJob = {}
    
    equipment.forEach(eq => {
      const jobId = eq.jobId || 'unknown'
      if (!equipmentByJob[jobId]) {
        equipmentByJob[jobId] = {
          id: jobId,
          title: `Job ${jobId}`,
          address: eq.address,
          status: eq.status || 'Unscheduled',
          flagNames: eq.flagNames || '',
          totalBudgetHrs: eq.totalBudgetHrs || 0,
          totalJobs: eq.totalJobs || 0,
          coordinates: eq.coordinates,
          date: eq.date,
          equipment: [],
          type: 'merged-equipment'
        }
      }
      equipmentByJob[jobId].equipment.push(eq)
    })
    
    return Object.values(equipmentByJob)
  }, [equipment])

  const getMergedCrew = useCallback(() => {
    const CrewByJob = {}
    
    crews.forEach(c => {
      const jobId = c.jobId || 'unknown'
      if (!CrewByJob[jobId]) {
        CrewByJob[jobId] = {
          id: jobId,
          status: c.status || 'Unscheduled',
          totalJobs: c.totalJobs || 0,
          flagNames: c.flagNames || '',
          totalBudgetHrs: c.totalBudgetHrs || 0,
          title: `Job ${jobId}`,
          address: c.address,
          coordinates: c.coordinates,
          date: c.date,
          crew: [],
          type: 'merged-crew'
        }
      }
      CrewByJob[jobId].crew.push(c)
    });
    
    return Object.values(CrewByJob)
  }, [crews])

  // ** Get data for current active tab
  const getCurrentData = useCallback(() => {
    switch (activeTab) {
      case 0: // Jobsite
        return jobSites
      case 1: // Crew
        // TODO: Implement crew data logic
        return getMergedCrew()
      case 2: // Equipment
        return getMergedEquipment()
      default:
        return jobSites
    }
  }, [activeTab, jobSites, getMergedEquipment, getMergedCrew])

  // ** Update markers when active tab or data changes
// ** Update markers when active tab or data changes
useEffect(() => {
  if (!map || !googleMaps) return

  const updateMarkers = async () => {
    // Clear existing markers and info windows
    markers.forEach(marker => {
      if (marker.infoWindow) {
        marker.infoWindow.close()
      }
      marker.setMap(null)
    })
    
    const currentData = getCurrentData()
    if (!currentData.length) return

    const newMarkers = []
    
    for (const item of currentData) {
      if (item.address) {
        try {
          const geocoder = new googleMaps.Geocoder()
          const result = await new Promise((resolve, reject) => {
            geocoder.geocode({ address: item.address }, (results, status) => {
              if (status === 'OK' && results[0]) {
                resolve(results[0])
              } else {
                reject(new Error(`Geocoding failed: ${status}`))
              }
            })
          })

          const isSelected = item.id === selectedJobSite?.id
          const marker = new googleMaps.Marker({
            position: result.geometry.location,
            map: map,
            title: item.title, // This is the default tooltip, we'll override with custom info window
            icon: getMarkerIcon(
              item.status || (item.type === 'merged-equipment' ? 'equipment' : 'default'),
              isSelected,
              theme,
              googleMaps,
              activeTab
            ),
            animation: isSelected ? googleMaps.Animation.BOUNCE : null
          })

          // Create custom info window content based on the image
          const infoWindowContent = createInfoWindowContent(item, theme)
          
          // Create info window
          const infoWindow = new googleMaps.InfoWindow({
            content: infoWindowContent,
            maxWidth: 300
          })

          // Store info window reference on marker
          marker.infoWindow = infoWindow

          // Add click listener for selection
          marker.addListener('click', () => {
            if (onJobSiteSelect) {
              onJobSiteSelect(item)
            }
          })

          // Add hover listeners for info window
          marker.addListener('mouseover', () => {
            infoWindow.open(map, marker)
          })

          marker.addListener('mouseout', () => {
            infoWindow.close()
          })

          newMarkers.push(marker)
        } catch (error) {
          console.error(`Failed to geocode address for ${item.title}:`, error)
        }
      }
    }
    
    setMarkers(newMarkers)
  }

  updateMarkers()
}, [map, googleMaps, selectedJobSite, theme, activeTab, onJobSiteSelect, jobSites, equipment, crews])


const createInfoWindowContent = (item, theme) => {
  const isDarkMode = theme.palette.mode === 'dark';
  let textPrimary = theme.palette.text.primary;
  let textSecondary = theme.palette.text.secondary;
  let bgPaper = theme.palette.background.paper;
  
  if (isDarkMode) {
    bgPaper = '#1e1e1e';
    textPrimary = '#e0e0e0';
    textSecondary = '#b0b0b0';
  }

  const getSoftBg = (color) => `${color}22`; 

  const getStatusChipStyles = (status) => {
    const s = status?.toLowerCase() || "default";

    const cfg = {
      scheduled: {
        color: theme.palette.warning.main,
        borderColor: theme.palette.warning.main,
        backgroundColor: getSoftBg(theme.palette.warning.main),
        dotColor: theme.palette.warning.main
      },
      ongoing: {
        color: theme.palette.info.main,
        borderColor: theme.palette.info.main,
        backgroundColor: getSoftBg(theme.palette.info.main),
        dotColor: theme.palette.info.main
      },
      "in progress": {
        color: theme.palette.info.main,
        borderColor: theme.palette.info.main,
        backgroundColor: getSoftBg(theme.palette.info.main),
        dotColor: theme.palette.info.main
      },
      completed: {
        color: theme.palette.success.main,
        borderColor: theme.palette.success.main,
        backgroundColor: getSoftBg(theme.palette.success.main),
        dotColor: theme.palette.success.main
      },
      canceled: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        backgroundColor: getSoftBg(theme.palette.error.main),
        dotColor: theme.palette.error.main
      },
      default: {
        color: textSecondary,
        borderColor: textSecondary,
        backgroundColor: getSoftBg(textSecondary),
        dotColor: textSecondary
      }
    };

    return cfg[s] || cfg.default;
  };

  const getStatusColorForBar = (status) => {
    const map = {
      Scheduled: theme.palette.warning.main,
      Ongoing: theme.palette.info.main,
      "In Progress": theme.palette.info.main,
      Completed: theme.palette.success.main,
      Canceled: theme.palette.error.main
    };
    return map[status] || theme.palette.primary.main;
  };

  const formatDate = (d) => {
    if (!d) return "Not scheduled";
    try {
      return new Date(d).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    } catch {
      return "Invalid date";
    }
  };
  const googleMapsOverrides = isDarkMode ? `
    /* Override Google Maps InfoWindow styling */
    .gm-style-iw { 
      background-color: ${bgPaper} !important; 
      border-radius: 8px !important;
      padding: 0 !important;
      border: 1px solid #424242 !important;
      box-shadow: none !important;
    }
    .gm-style-iw-c { 
      background-color: ${bgPaper} !important; 
      border-radius: 8px !important;
      padding: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
    .gm-style-iw-tc::after, 
    .gm-style-iw-t::after {
      background: ${bgPaper} !important;
      box-shadow: none !important;
    }
    .gm-style-iw-d {
      overflow: hidden !important;
      border-radius: 8px !important;
    }
    /* Remove Google's default border/shadow */
    .gm-style-iw-chr {
      display: none !important;
    }
    /* Remove any white background from parent containers */
    .gm-style > div:first-child > div:first-child {
      background: transparent !important;
    }
    /* Remove close button border */
    button.gm-ui-hover-effect {
      background: ${bgPaper} !important;
      border: none !important;
    }
  ` : '';

  if (item.type === "merged-equipment") {
    return `
      <div style="
        padding: 12px; 
        font-family: 'DM Sans'; 
        max-width: 280px; 
        background:${bgPaper}; 
        color:${textPrimary};
        ${isDarkMode ? 'border-radius: 8px; border: 1px solid #424242;' : ''}
        width: 100%;
        height: 100%;
        box-sizing: border-box;
      ">
        <style>
          .gm-ui-hover-effect { display:none !important; }
          ${googleMapsOverrides}
          /* Force dark background on all Google containers */
          div[style*="background-color: white"],
          div[style*="background-color: rgb(255, 255, 255)"],
          div[style*="background-color: #fff"] {
            background-color: ${bgPaper} !important;
          }
        </style>

        <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
          <span style="font-size:13px; color:${textSecondary};">Job ID:</span>
          <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.id}</span>
        </div>

        <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
          <span style="font-size:13px; color:${textSecondary}; white-space:nowrap;">Address:</span>
          <span style="font-size:13px; font-weight:bold; text-align:right; flex:1; color:${textPrimary};">${item.address}</span>
        </div>

        <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
          <span style="font-size:13px; color:${textSecondary};">Jobs:</span>
          <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.totalJobs}</span>
        </div>

        <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
          <span style="font-size:13px; color:${textSecondary};">Est. Man Hours:</span>
          <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.totalBudgetHrs}h</span>
        </div>

        <div style="display:flex; justify-content:space-between;">
          <span style="font-size:13px; color:${textSecondary};">Equipment:</span>
          <div style="display:flex; flex-wrap:wrap; gap:4px; justify-content:flex-end; max-width:160px;">
            ${item.equipment
              .map(
                (eq) => `
                <span style="
                  background:${theme.palette.warning.main};
                  color:${isDarkMode ? '#1a1a1a' : 'white'};
                  padding:2px 8px;
                  border-radius:12px;
                  font-size:11px;
                  font-weight:500;
                ">
                  ${eq.assetName || eq.title}
                </span>`
              )
              .join("")}
          </div>
        </div>
      </div>
    `;
  }
  if (item.type === "merged-crew") {
    return `
      <div style="
        padding:12px; 
        font-family:'DM Sans'; 
        max-width:280px; 
        background:${bgPaper}; 
        color:${textPrimary};
        ${isDarkMode ? 'border-radius: 8px; border: 1px solid #424242;' : ''}
        width: 100%;
        height: 100%;
        box-sizing: border-box;
      ">
        <style>
          .gm-ui-hover-effect{display:none!important;}
          ${googleMapsOverrides}
          /* Force dark background on all Google containers */
          div[style*="background-color: white"],
          div[style*="background-color: rgb(255, 255, 255)"],
          div[style*="background-color: #fff"] {
            background-color: ${bgPaper} !important;
          }
        </style>

        <div style="display:flex; flex-direction:column; gap:8px;">
          <div style="display:flex; justify-content:space-between;">
            <span style="font-size:13px; color:${textSecondary};">Job ID:</span>
            <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.id}</span>
          </div>

          <div style="display:flex; justify-content:space-between;">
            <span style="font-size:13px; color:${textSecondary};">Address:</span>
            <span style="font-size:13px;font-weight:bold; color:${textPrimary}; text-align:right; max-width:160px;">${item.address}</span>
          </div>

          <div style="display:flex; justify-content:space-between;">
            <span style="font-size:13px; color:${textSecondary};">Jobs:</span>
            <span style="font-size:13px; font-weight:bold;color:${textPrimary};">${item.totalJobs}</span>
          </div>

          <div style="display:flex; justify-content:space-between;">
            <span style="font-size:13px; color:${textSecondary};">Est. Man Hours:</span>
            <span style="font-size:13px;font-weight:bold; color:${textPrimary};">${item.totalBudgetHrs}h</span>
          </div>

          <div style="display:flex; justify-content:space-between;">
            <span style="font-size:13px; color:${textSecondary};">Crew Members:</span>
             <div style="display:flex; flex-wrap:wrap; gap:4px; justify-content:flex-end; max-width:160px;">
              ${item.crew
                .map(
                  (c) => `
                  <span style="
                    background:${theme.palette.info.main};
                    color:${isDarkMode ? '#1a1a1a' : 'white'};
                    padding:2px 8px;
                    border-radius:11px;
                    font-size:12px;
                    font-weight:500;">
                    ${c.employeeName} ${c.skillType ? `- ${c.skillType}` : ""}
                  </span>`
                )
                .join("")}
            </div>
          </div>
        </div>
      </div>
    `;
  }
  const chip = getStatusChipStyles(item.status);
  const barColor = getStatusColorForBar(item.status);

  return `
    <div style="
      padding:12px; 
      max-width:290px; 
      background:${bgPaper}; 
      font-family:'DM Sans'; 
      color:${textPrimary};
      ${isDarkMode ? 'border-radius: 8px; border: 1px solid #424242;' : ''}
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    ">
      <style>
        .gm-ui-hover-effect{display:none!important;}
        ${googleMapsOverrides}
        /* Force dark background on all Google containers */
        div[style*="background-color: white"],
        div[style*="background-color: rgb(255, 255, 255)"],
        div[style*="background-color: #fff"] {
          background-color: ${bgPaper} !important;
        }
      </style>

      ${
        item.title
          ? `<div style="font-size:16px; font-weight:bold; margin-bottom:6px;">${item.title}</div>`
          : ""
      }

      <div style="
        display:inline-flex;
        align-items:center;
        background:${chip.backgroundColor};
        color:${chip.color};
        border:1px solid ${chip.borderColor};
        border-radius:12px;
        padding:2px 8px;
        font-size:10px;
        margin-bottom:10px;
        font-weight:500;
      ">
        <div style="width:6px; height:6px; border-radius:50%; background:${chip.dotColor}; margin-right:4px;"></div>
        ${item.status}
      </div>

      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span style="font-size:13px; color:${textSecondary};">Job ID:</span>
        <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.id || "N/A"}</span>
      </div>

      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span style="font-size:13px; color:${textSecondary};">Customer:</span>
        <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.customerName || "N/A"}</span>
      </div>

      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span style="font-size:13px; color:${textSecondary};">Est. Man Hours:</span>
        <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${item.totalBudgetHrs || "0"}h</span>
      </div>

      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span style="font-size:13px; color:${textSecondary};">Schedule Start:</span>
        <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${formatDate(item.startDate)}</span>
      </div>

      <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
        <span style="font-size:13px; color:${textSecondary};">Schedule End:</span>
        <span style="font-size:13px; font-weight:bold; color:${textPrimary};">${formatDate(item.endDate)}</span>
      </div>

      <div style="width:100%; height:4px; background:${barColor}; border-radius:2px; margin-top:10px;"></div>
    </div>
  `;
};

const makeRow = (label, value, secondary, primary) => `
  <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
    <span style="font-size:13px; color:${secondary}; white-space:nowrap;">${label}</span>
    <span style="
      font-size:13px;
      font-weight:bold;
      color:${primary};
      text-align:right;
      max-width:150px;
      word-break:break-word;
    ">
      ${value}
    </span>
  </div>
`;


function calculateCompletionPercentage(totalJobs, completedJobs) {
  if (totalJobs <= 0) return 0; 

  const percentage = (completedJobs / totalJobs) * 100;
  return `(${Math.round(percentage * 100) / 100}%)` 
}

  useEffect(() => {
    if (selectedJobSite && map && googleMaps) {
      const centerMapOnSelected = async () => {
        try {
          let location = null

          if (selectedJobSite.coordinates) {
            location = selectedJobSite.coordinates
          } else if (selectedJobSite.address) {
            const geocoder = new googleMaps.Geocoder()
            const result = await new Promise((resolve, reject) => {
              geocoder.geocode({ address: selectedJobSite.address }, (results, status) => {
                if (status === 'OK' && results[0]) {
                  resolve(results[0])
                } else {
                  reject(new Error(`Geocoding failed: ${status}`))
                }
              })
            })
            location = result.geometry.location
          }

          if (location) {
            map.setCenter(location)
            map.setZoom(15)
          }
        } catch (error) {
          console.error('Failed to center on selected item:', error)
        }
      }

      centerMapOnSelected()
    }
  }, [selectedJobSite, map, googleMaps])

  // ** Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

const renderCardContent = (item) => {
    // Check if it's dark mode
    const isDarkMode = theme.palette.mode === 'dark';
    
    // Job ID chip colors - keep #003A70 for light mode, use text.primary for dark mode
    const jobIdColor = isDarkMode ? theme.palette.text.primary : '#003A70';
    const jobIdBgColor = isDarkMode ? 'rgba(224, 224, 224, 0.1)' : 'rgba(0, 58, 112, 0.1)';

    if (item.type === 'merged-equipment') {
      return (
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CustomChip
                sx={{
                  fontSize: '0.7rem',
                  borderRadius: '12px',
                  height: '24px',
                  color: jobIdColor, 
                  backgroundColor: jobIdBgColor, 
                  '& .MuiChip-label': {
                    color: jobIdColor, 
                  },
                }}
                skin="light"
                label={`Job ID: ${item.id}`}
              />
              
              {/* Flag Chip */}
              {item.flagNames && (
                <CustomChip
                  sx={{
                    fontSize: '0.7rem',
                    borderRadius: '12px',
                    height: '24px',
                    color: item.flagNames.includes('Under Budget') ? '#1E88E5' : '#F44336', 
                    backgroundColor: item.flagNames.includes('Under Budget') ? 'rgba(30, 136, 229, 0.1)' : 'rgba(244, 67, 54, 0.1)', 
                    '& .MuiChip-label': {
                      color: item.flagNames.includes('Under Budget') ? '#1E88E5' : '#F44336', 
                    },
                  }}
                  skin="light"
                  label={item.flagNames}
                />
              )}
            </Box>
              
            
            <Box sx={{ display: "flex", gap: 1 }}>
              <Icon icon="ci:building-02" width={15} height={15} />
              <Icon icon="streamline-ultimate:multiple-users-1" width={15} height={15} />
              <Icon icon="solar:money-bag-broken" width={15} height={15} />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
            {item?.status && (
              <CustomChip
                skin="light"
                sx={{
                  cursor: 'pointer', 
                  fontSize: '0.65rem',
                  borderRadius: '12px',
                  height: '22px',
                  minHeight: '22px',
                  padding: '0 8px',
                  '& .MuiChip-label': {
                    padding: '0 4px',
                    display: 'flex',
                    alignItems: 'center',
                  }
                }}
                color={
                  item?.status.toLowerCase() === "scheduled" ? "warning" : 
                  item.status.toLowerCase() === "ongoing" ? "info" : 
                  item.status.toLowerCase() === "completed" ? "success" :
                  item.status.toLowerCase() === "canceled" ? "error" : "info"
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box 
                      sx={{ 
                        mr: 0.5,
                        width: 6, 
                        height: 6, 
                        borderRadius: '50%',
                        backgroundColor: 'currentColor',
                        opacity: 0.8
                      }} 
                    />
                    {item.status}
                  </Box>
                }
              />
            )}
          </Box>
          
          <Typography variant="body1" color="text.secondary" >
            {item.address}
          </Typography>
          
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ display: 'block', mt: 1 }}
          >
            Jobs: {item.totalJobs || 0}
          </Typography>
          
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ display: 'block', mt: 1 }}
          >
            Est. Man Hours: {item.totalBudgetHrs || 0}h
          </Typography>
          
          {item.date && (
            <Typography variant="caption" color="text.secondary" gutterBottom>
              Date: {item.date}
            </Typography>
          )}          
          
          <EquipmentList>
            {item.equipment.map((eq, index) => (
              <Chip
                key={index}
                label={eq.assetName || eq.title}
                size="small"
                variant="filled"
                color="warning"
                title={eq.assetName || eq.title}
              />
            ))}
          </EquipmentList>
          
          <Box 
            sx={{ 
              width: '100%', 
              height: '4px', 
              backgroundColor: theme.palette.warning.main,
              mt: 2,
              mb:1,
              borderRadius: '2px'
            }} 
          />
        </CardContent>
      )
    }

    if (item.type === 'merged-crew') {
      return (
        <CardContent sx= {{ p: 2.5}}>
           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CustomChip
            sx={{
              fontSize: '0.7rem',
              borderRadius: '12px',
              height: '24px',
              color: jobIdColor, 
              backgroundColor: jobIdBgColor, 
              '& .MuiChip-label': {
                color: jobIdColor, 
              },
            }}
            skin="light"
            label={`Job ID: ${item.id}`}
          />
          
          {/* Flag Chip */}
          {item.flagNames && (
            <CustomChip
              sx={{
                fontSize: '0.7rem',
                borderRadius: '12px',
                height: '24px',
                color: item.flagNames.includes('Under Budget') ? '#1E88E5' : '#F44336', 
                backgroundColor: item.flagNames.includes('Under Budget') ? 'rgba(30, 136, 229, 0.1)' : 'rgba(244, 67, 54, 0.1)', 
                '& .MuiChip-label': {
                  color: item.flagNames.includes('Under Budget') ? '#1E88E5' : '#F44336', 
                },
              }}
              skin="light"
              label={item.flagNames}
            />
          )}
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Icon icon="ci:building-02" width={15} height={15} />
          <Icon icon="streamline-ultimate:multiple-users-1" width={15} height={15} />
          <Icon icon="solar:money-bag-broken" width={15} height={15} />
        </Box>
      </Box>
      
      {/* Status Row - below the first row */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        {item?.status && (
          <CustomChip
            skin="light"
            sx={{
              cursor: 'pointer', 
              fontSize: '0.65rem',
              borderRadius: '12px',
              height: '22px',
              minHeight: '22px',
              padding: '0 8px',
              '& .MuiChip-label': {
                padding: '0 4px',
                display: 'flex',
                alignItems: 'center',
              }
            }}
            color={
              item?.status.toLowerCase() === "scheduled" ? "warning" : 
              item.status.toLowerCase() === "ongoing" ? "info" : 
              item.status.toLowerCase() === "completed" ? "success" :
              item.status.toLowerCase() === "canceled" ? "error" : "info"
            }
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box 
                  sx={{ 
                    mr: 0.5,
                    width: 6, 
                    height: 6, 
                    borderRadius: '50%',
                    backgroundColor: 'currentColor',
                    opacity: 0.8
                  }} 
                />
                {item.status}
              </Box>
            }
          />
        )}
      </Box>
      
      <Typography variant="body1" color="text.secondary" >
        {item.address}
      </Typography>
         
           <Typography 
    variant="body2" 
    color="text.secondary" 
   
  >
    Jobs: {item.totalJobs || 0}
  </Typography>
   <Typography 
    variant="body2" 
    color="text.secondary" 
  >
    Est. Man Hours: {item.totalBudgetHrs || 0}h
  </Typography>

          {item.date && (
            <Typography variant="caption" color="text.secondary" gutterBottom>
              Date: {item.date}
            </Typography>
          )}          
          <EquipmentList sx={{mt:1}}>
            {item.crew.map((c, index) => (
              <Chip
                key={index}
                label={`${c.employeeName} ${c.skillType? ' - '+ c.skillType : ''}` || c.title}
                size="small"
                variant="filled"
                color="info"
                title={`${c.employeeName} ${c.skillType? ' - '+ c.skillType : ''}` || c.title}
              />
            ))}
          </EquipmentList>
          <Box 
          sx={{ 
            width: '100%', 
            height: '4px', 
            backgroundColor: theme.palette.info.main,
            mt: 2,
            mb: 1,
            borderRadius: '2px'
          }} 
        />
        </CardContent>
      )
    }

    return (
      
    <CardContent sx={{ p: 3 }}> 
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CustomChip
            sx={{
              fontSize: '0.7rem',
              borderRadius: '12px',
              height: '24px',
              color: jobIdColor, 
              backgroundColor: jobIdBgColor, 
              '& .MuiChip-label': {
                color: jobIdColor, 
              },
            }}
            skin="light"
            label={`Job ID: ${item.id}`}
          />
          
          {/* Flag Chip */}
          {item.flagNames && (
            <CustomChip
              sx={{
                fontSize: '0.68rem',
                borderRadius: '10px',
                height: '24px',
                color: item.flagNames.includes('Under Budget') ? '#1E88E5' : '#F44336', 
                backgroundColor: item.flagNames.includes('Under Budget') ? 'rgba(30, 136, 229, 0.1)' : 'rgba(244, 67, 54, 0.1)', 
                '& .MuiChip-label': {
                  color: item.flagNames.includes('Under Budget') ? '#1E88E5' : '#F44336', 
                },
              }}
              skin="light"
              label={item.flagNames}
            />
          )}
        </Box>
          
        <Box sx={{ display: "flex", gap: 1 }}>
          <Icon icon="ci:building-02" width={15} height={15} />
          <Icon icon="streamline-ultimate:multiple-users-1" width={15} height={15} />
          <Icon icon="solar:money-bag-broken" width={15} height={15} />
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        {item?.status && (
          <CustomChip
            skin="light"
            sx={{
              cursor: 'pointer', 
              fontSize: '0.65rem',
              borderRadius: '12px',
              height: '22px',
              minHeight: '22px',
              padding: '0 8px',
              '& .MuiChip-label': {
                padding: '0 4px',
                display: 'flex',
                alignItems: 'center',
              }
            }}
            color={
              item?.status.toLowerCase() === "scheduled" ? "warning" : 
              item.status.toLowerCase() === "ongoing" ? "info" : 
              item.status.toLowerCase() === "completed" ? "success" :
              item.status.toLowerCase() === "canceled" ? "error" : "info"
            }
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box 
                  sx={{ 
                    mr: 0.5,
                    width: 6, 
                    height: 6, 
                    borderRadius: '50%',
                    backgroundColor: 'currentColor',
                    opacity: 0.8
                  }} 
                />
                {item.status}
              </Box>
            }
          />
        )}
      </Box>
      
      <Typography variant="body2" color="text.secondary">
        {item.address}
      </Typography>


        <Typography 
          variant="body2" 
          color="text.secondary" 
        
        >
          Jobs: {item.totalJobs || 0}
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary" 
        
        >
          Est. Man Hours: {item.totalBudgetHrs || 0}h
        </Typography>


        {/* Schedule Start - on new line */}
        {item?.startDate && (
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ display: 'block', mt: 0.5 }}
          >
            Schedule Start: {item.startDate || 'No date'}
          </Typography>
        )}


        {item?.createdDate && (
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ display: 'block', mt: 0.5 }}
          >
            Date: {item.createdDate || 'No date'}
          </Typography>
        )}

      
        {item?.endDate && (
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ display: 'block', mt: 0.5 }}
          >
            Schedule End: {item.endDate || 'No date'}
          </Typography>
        )}


        <Box 
          sx={{ 
            width: '100%', 
            height: '4px', 
            backgroundColor: getStatusColor(item.status, theme),
            mt: 1.5,
            borderRadius: '2px'
          }} 
        />
      </CardContent>
    )
  }
  const currentData = getCurrentData()

  return (
    <>
      <MapContainer sx={{ position: 'relative' }}>
        <TabsContainer>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Jobsite" />
            <Tab label="Crew" />
            <Tab label="Equipment" />
          </Tabs>
        </TabsContainer>
        <DateFilterContainer>
          <Box display="flex" alignItems="center" gap={2} pt={2}>
          
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={selectedDate ? dayjs(selectedDate) : null}
                onChange={(newDate) => {
                  if (newDate) {
                    const startOfDay = newDate.startOf("day"); // Dayjs start of day
                    setSelectedDate(startOfDay.toDate()); 
                    if (onDateChange) onDateChange(startOfDay.toDate());
                  }
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    label: "Select Date",
                  },
                  field: {
                    clearable: true,
                  },
                }}
              />
            </LocalizationProvider>

            {/* Display Formatted Date */}
            {/* <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600,
                color: theme.palette.primary.main,
                minWidth: 130
              }}
            >
              {GetFormatedDateStamp(selectedDate)}
            </Typography> */}

            {/* Today Button */}
            <IconButton
              onClick={handleTodayClick}
              size="small"
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                height: 58, 
                padding: "6px 12px", 
                height: 40, 
                "&:hover": {
                  backgroundColor: theme.palette.action.hover, 
                  transform: "translateY(-1px)",
                  boxShadow: theme.shadows[1],
                  color: "inherit", 
                },
                display: "flex",
                alignItems: "center",
                gap: 1,
                transition: "all 0.2s ease-in-out",
              }}
            >
              <Today fontSize="small" />
              <Typography variant="body1" sx={{ fontWeight: 550 ,ml:1.5}}>
                Today
              </Typography>
            </IconButton>
          </Box>

          {/* Filter Button */}
          <IconButton
            onClick={onFilterClick}
            sx={{
              border: `1px solid ${theme.palette.divider}`,
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <FilterList />
          </IconButton>
        </DateFilterContainer>

        {/* Two Column Layout */}
        <ContentContainer>
          {/* Left Column - Cards */}
          <JobsColumn>
            {currentData.map((item) => (
              <JobCard
                key={item.id}
                selected={item.id === selectedJobSite?.id}
                onClick={() => onJobSiteSelect?.(item)}
              >
                {renderCardContent(item)}
              </JobCard>
            ))}
            {currentData.length === 0 && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Typography color="text.secondary">No data available</Typography>
              </Box>
            )}
          </JobsColumn>

          {/* Right Column - Map */}
          <MapColumn>
            <div
              ref={mapRef}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: theme.shape.borderRadius,
              }}
            />
            {activeTab === 0 && (
             <Box
              sx={{
                position: "absolute",
                bottom: 40,
                right: 80,
                backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : "white",
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                padding: 3.5,
                boxShadow: theme.shadows[2],
                zIndex: 10,
                color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'inherit',
              }}
            >
              <Typography 
                variant="h6" 
                sx={{ 
                  mb: 0.5, 
                  fontWeight: "bold",
                  color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'inherit',
                }}
              >
                Jobs Legend
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
              >
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    bgcolor: theme.palette.info.main,
                    borderRadius: "50%",
                    mr: 1,
                  }}
                />
                <Typography 
                  variant="body2"
                  sx={{ color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'inherit' }}
                >
                  In Progress Jobs
                </Typography>
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
              >
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    bgcolor: theme.palette.success.main,
                    borderRadius: "50%",
                    mr: 1,
                  }}
                />
                <Typography 
                  variant="body2"
                  sx={{ color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'inherit' }}
                >
                  Completed Jobs
                </Typography>
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
              >
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    bgcolor: theme.palette.error.main,
                    borderRadius: "50%",
                    mr: 1,
                  }}
                />
                <Typography 
                  variant="body2"
                  sx={{ color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'inherit' }}
                >
                  Canceled Jobs
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    bgcolor: theme.palette.warning.main,
                    borderRadius: "50%",
                    mr: 1,
                  }}
                />
                <Typography 
                  variant="body2"
                  sx={{ color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'inherit' }}
                >
                  Scheduled Jobs
                </Typography>
              </Box>
            </Box>
            )}
            {!googleMaps && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100%"
              >
                <Typography>Loading map...</Typography>
              </Box>
            )}
          </MapColumn>
        </ContentContainer>
      </MapContainer>
      <Card sx={{ mt: 4 }}>
        <CardHeader 
          title='Job List'
          action={
            <Button variant='contained' color='main'>Bulk Assign</Button>
          }
        />
        <CardContent>
          <DataGridPro
            pagination
            rows={jobList}
            rowHeight={62}
            columns={columnsJobList}
            pageSizeOptions={[10, 50, { value: jobList.length, label: "Show All" }]}
            disableRowSelectionOnClick
            paginationModel={jobListPaginationModel}
            onPaginationModelChange={setJobListPaginationModel}
            sx={{
              minHeight: 350,
              maxHeight: 550,
              "& .MuiDataGrid-columnHeaderTitle": {
                textTransform: "none",
              },
            }}
          />
        </CardContent>
      </Card>

      <JobDetailDialog
        open={openJobDetail}
        handleClose={handleCloseJobDetail}
        method={'detail'}
        entity={'workOrder-detail'} 
        rules={rules} 
        workReq={selectedWorkReq} 
        job={selectedJob}
        setJob={setSelectedJob}
        fetchWorkRequirements={fetchWorkRequirements}
        setLoading={setLoading} 
        toast={toast}
        fetchRequests={fetchJobs}
      />
    </>
  );
}

// ** Updated marker icon function with specified icons
const getMarkerIcon = (status, isSelected, theme, googleMaps, activeTab) => {
  if (!googleMaps) return null;

  const colors = {
    Scheduled: theme.palette.warning.main,
    OnProgress: theme.palette.info.main,
    Ongoing: theme.palette.info.main,
    Completed: theme.palette.success.main,
    Canceled: theme.palette.error.main,
    Equipment: '#003A70',
    Default: '#003A70'
  }
  
  const size = isSelected ? 40 : 30
  
  let svgContent = '';
  let color = colors[status] || colors.Default;
  
  switch (activeTab) {
    case 1: // Crew - Font Awesome Users icon with visually-round bg (keeps r=366)
  svgContent = `
    <svg width="${size}" height="${size}" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
      <!-- Compress X by 0.8 around the circle center (320,256) so r=366 looks round -->
      <g transform="translate(320 256) scale(0.8 1) translate(-320 -256)">
        <circle cx="330" cy="286" r="376" fill="white" />
      </g>

      <!-- Optional subtle stroke for separation -->
      <g transform="translate(320 256) scale(0.8 1) translate(-320 -256)">
        <circle cx="320" cy="256" r="366" fill="none" stroke="#D9D9D9" stroke-width="2" opacity="0.6"/>
      </g>

      <!-- Font Awesome Solid Users Icon (kept untransformed so it sits on top) -->
      <path fill="#1A6A4F" d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/>
    </svg>
  `;
  break;

   case 2: // Equipment - Fluent UI Vehicle Van icon (outlined)
  svgContent = `
    <svg width="${size}" height="${size}" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <!-- White circular background -->
      <rect width="16" height="16" rx="8" fill="white"/>

      <!-- Fluent UI Vehicle Van Icon (outlined style) -->
      <path
        d="M2 6a1 1 0 0 1 1-1h7.38a1 1 0 0 1 .89.55l1.36 2.6a1 1 0 0 1 .12.45V10h.75a.5.5 0 0 1 0 1h-.28a1.5 1.5 0 1 1-2.94 0H6.72a1.5 1.5 0 1 1-2.94 0H3a1 1 0 0 1-1-1V6Zm1 0v4h.78a1.5 1.5 0 0 1 2.94 0h3.56a1.5 1.5 0 0 1 2.94 0h.78V8.2L11.62 6H3Zm1.75 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm6.5 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
        fill="none"
        stroke="#1A6A4F"
        stroke-width="0.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `;
  break;


    default: // Jobsite - colored dot
      svgContent = `
        <svg width="${size}" height="${size}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="${color}" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          ${isSelected ? `<circle fill="${theme.palette.common.white}" cx="12" cy="9" r="3"/>` : ''}
        </svg>
      `;
  }
  
  return {
    url: `data:image/svg+xml;base64,${btoa(svgContent)}`,
    scaledSize: new googleMaps.Size(size, size),
    anchor: new googleMaps.Point(size / 2, size)
  };
}
const getMapStyles = (theme) => {
    const isDark = theme.palette.mode === 'dark'
    
    return [
      {
        "elementType": "geometry",
        "stylers": [{ "color": isDark ? "#1a1a2e" : "#f0f2f5" }]
      },
      {
        "elementType": "labels.icon",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [{ "color": isDark ? "#e6e6e6" : "#5f6368" }]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [{ "color": isDark ? "#1a1a2e" : "#ffffff" }]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "administrative.land_parcel",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "administrative.neighborhood",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "poi",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{ "color": isDark ? "#2d3748" : "#ffffff" }]
      },
      {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [{ "color": isDark ? "#4a5568" : "#e2e8f0" }]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": isDark ? "#e6e6e6" : "#4a5568" }]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{ "color": isDark ? "#4a5568" : "#f7fafc" }]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{ "color": isDark ? "#2d3748" : "#cbd5e0" }]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": isDark ? "#e6e6e6" : "#4a5568" }]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": isDark ? "#e6e6e6" : "#4a5568" }]
      },
      {
        "featureType": "transit",
        "stylers": [{ "visibility": "off" }]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{ "color": isDark ? "#0f3460" : "#bee3f8" }]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": isDark ? "#4e6a87" : "#90cdf4" }]
      }
    ]
  }

const getStatusColor = (status, theme) => {
    const colors = {
      Scheduled: theme.palette.warning.main,
      Ongoing: theme.palette.info.main,
      'On Hold' : theme.palette.info.main,
      Completed: theme.palette.success.main,
      Canceled: theme.palette.error.main
    }
    return colors[status] || theme.palette.primary.main
}

export default MapComponent